import type { DeepReadonly } from 'ts-essentials';

import type { ProductKind } from './product';

export const EQUIVALENCY_TYPE = 'equivalency';

export const EQUIVALENCY_UNIT = 'g';

interface NuProductTypeRequired {
  id: string | number;
  product_subtype: string | null;
  product_type: ProductKind;
}

export interface NuProductType extends NuProductTypeRequired {
  _destroy?: boolean;
}

export interface RuleProduct extends NuProductType {
  cart_limit_rule_product_type_id: string | number;
}

export type CartLimitRule = DeepReadonly<{
  _destroy?: boolean;
  id?: string | number;
  limit_unit: string;
  limit_value: number;
  product_group_name: string;
  product_types: RuleProduct[];
  rule_type: 'product' | 'equivalency';
}>;

export interface CartLimitPolicy {
  cart_limit_rules: CartLimitRule[];
  id: string | number;
  name: string;
}
